var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VGridRow',[_c('SelectorAccidentLaborProtection',{attrs:{"accident":_vm.accident,"is-create-accident":_vm.isCreateAccident},on:{"updateInformation":_vm.updateInformation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }